(function($) {

	var getUrlParameter = function(sParam) {
		// Thanks http://www.jquerybyexample.net/2012/06/get-url-parameters-using-jquery.html
		var sPageURL = decodeURIComponent(window.location.search.substring(1)),
			sURLVariables = sPageURL.split('&'),
			sParameterName,
			i;

		for (i = 0; i < sURLVariables.length; i++) {
			sParameterName = sURLVariables[i].split('=');
			if (sParameterName[0] === sParam) {
				return sParameterName[1] === undefined ? true : sParameterName[1];
			}
		}
	};

	$(document).on('ready.search', function() {

		var searchTerm = getUrlParameter('ct[st]');

		if (searchTerm && searchTerm !== undefined && searchTerm !== '') {

			// https://jsfiddle.net/julmot/ova17daa/
			var options = {};
			var flags = searchTerm.replace(/.*\/([gimy]*)$/, '$1');
			var pattern = searchTerm.replace(new RegExp('^/(.*?)/gi$'), '$1');
			var regex = new RegExp(pattern, 'gi');
			$('[data-main]').markRegExp(regex, options);

			$('[data-tab-content]').each(function() {
				var html = $(this).html();
				if (html.indexOf(searchTerm) >= 0) {
					var $tab = $('[role="tab"]', $(this).closest('[data-accordion-item]'));
					if($tab.attr('aria-selected') === 'false'){
						$tab.click();
					}
				}
			});

		}

	});

}(jQuery));
